/**
 * مبدّل المقياس في صفحات الملخص: المطلوب / المستلم / الفرق
 */
import React from "react";
import { MEASURE_LABELS } from "../../types";
import type { Measure } from "../../types";

const ORDER: Measure[] = ["requested", "received", "diff"];

export default function MeasureToggle({ value, onChange }: { value: Measure; onChange: (m: Measure) => void }) {
  return (
    <div className="card mb-4 flex flex-wrap items-center gap-2 print:hidden">
      <span className="text-sm font-medium text-gray-700 ml-2">عرض:</span>
      {ORDER.map((m) => (
        <button key={m} type="button" onClick={() => onChange(m)}
          className={`px-3 py-1 text-xs rounded-full border transition ${
            value === m ? "bg-primary-600 text-white border-primary-600"
                        : "border-gray-300 text-gray-600 hover:border-primary-400"
          }`}>
          {MEASURE_LABELS[m]}
        </button>
      ))}
      {value !== "requested" && (
        <span className="text-[11px] text-gray-500 mr-2">
          يشمل الطلبات المؤكَّد استلامها فقط
          {value === "diff" && " — السالب نقص، والموجب زيادة"}
        </span>
      )}
    </div>
  );
}
